import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/89379124fe3adbc72539936686dd14e0.jpg"
          alt="廿日市 塾 学習塾NICKの教室風景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
        <div className="inline-block bg-white/95 px-8 py-3 rounded-full mb-6">
          <p className="text-base font-medium text-[#1a2332]">うちの子、塾に通うのが楽しくなってきたみたい。知らなかったわ、廿日市にこんな良い塾があったなんて</p>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-white mb-8 leading-tight">
          <strong>廿日市の塾</strong>なら<br />学習塾NICK<br />成績アップと志望校合格を実現
        </h1>

        <p className="text-xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
          学習塾NICKは、廿日市市大野で中学生を支える地域密着型の<strong>塾</strong>です。<strong>少人数指導と<br />集団指導のハイブリッド型</strong>で一人ひとりに合わせた<strong>定期テスト対策</strong>と<strong>高校受験対策</strong>を行い、<br /><strong>成績アップ</strong>と志望校合格を実現します。
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          <Link
            to="/trial#trial-form-section"
            className="bg-[#6b4423] text-white px-12 py-6 rounded-full text-xl font-bold hover:bg-[#5a3a1e] transition-all hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
          >
            無料体験に申し込む
            <i className="ri-arrow-right-line text-2xl"></i>
          </Link>
          <a
            href="tel:0829-78-1638"
            className="bg-white text-[#6b4423] px-12 py-6 rounded-full text-xl font-bold hover:bg-gray-50 transition-all hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line text-2xl"></i>
            0829-78-1638
          </a>
        </div>

        <p className="text-white/80 mt-8 text-sm">
          学習塾NICKは廿日市市、宮島、阿品、大竹市など周辺地域からも通塾可能です
        </p>
      </div>
    </section>
  );
}
